import React, { useState } from "react";
import Swal from "sweetalert2";
import { Button, Label, Input } from "reactstrap";
import axios from "axios";

/**
 * Reseteo de contraseña de otro usuario, desde el listado.
 * Lo hace un administrador, así que no se pide la contraseña actual.
 * (El cambio de la contraseña propia vive en Password.jsx, desde el menú de usuario.)
 */
function PasswordUsuario({ idUsuario, nombre, onListo }) {
  const URL_PASSWORD = `${process.env.REACT_APP_URL_USERS}/passwordCliente/${idUsuario}`;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [passwordNuevo, setPasswordNuevo] = useState("");
  const [passwordVerificar, setPasswordVerificar] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  function cambiarPassword() {
    if (!passwordNuevo) {
      Swal.fire({ icon: "warning", title: "Falta la contraseña" });
      return;
    }
    if (passwordNuevo !== passwordVerificar) {
      Swal.fire({ icon: "error", title: "Oops...", text: "La nueva contraseña no coincide" });
      return;
    }
    setValidaBoton(false);

    axios
      .patch(URL_PASSWORD, { password: passwordNuevo }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: "Cambio Contraseña", detalle: nombre || idUsuario,
        }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }).catch(() => {});

        setPasswordNuevo("");
        setPasswordVerificar("");
        setValidaBoton(true);
        if (onListo) onListo();
        Swal.fire("¡Listo!", "Contraseña actualizada con éxito", "success");
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      {nombre ? (
        <p style={{ fontSize: "0.8rem", color: "#64748b", marginBottom: 12 }}>
          Nueva contraseña para <strong>{nombre}</strong>
        </p>
      ) : null}

      <Label>Contraseña nueva</Label>
      <Input
        required
        value={passwordNuevo}
        onChange={(e) => setPasswordNuevo(e.target.value)}
        type="password"
        placeholder="Contraseña nueva"
      />

      <Label className="mt-2">Ingrésala nuevamente</Label>
      <Input
        required
        value={passwordVerificar}
        onChange={(e) => setPasswordVerificar(e.target.value)}
        type="password"
        placeholder="Verificar contraseña"
      />

      <Button color="success" className="mt-3" onClick={cambiarPassword} disabled={!validaBoton}>
        Guardar
      </Button>
    </>
  );
}

export default PasswordUsuario;
